var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSqarMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 4.49023V18.6441H22V4.49023H2ZM20 6.25946V6.67081L12 11.3885L4 6.67081V6.25946H20ZM4 16.8748V8.79743L12 13.516L20 8.79743V16.8748H4Z",
    fill: "#B4BAC2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSqarMail);
export default __webpack_public_path__ + "static/media/sqar-mail.41725e4127697b4825f2e932a9f3ed61.svg";
export { ForwardRef as ReactComponent };